export default __webpack_public_path__ + "static/go-to@992-12a8f98ed7e748f073aa338cddfccee5.svg";